import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { Modal, Button } from '../../root/components/common'

const useStyles = makeStyles(theme => ({
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.textPrimary,
        fontFamily: theme.fontFamily,
        marginBottom: 12
    },
    body: {
        fontSize: 14,
        color: theme.textPrimary,
        fontFamily: theme.fontFamily,
        lineHeight: 1.5
    },
    target: {
        marginTop: 12,
        padding: 12,
        background: theme.lightBlueGrey,
        border: theme.border,
        borderRadius: theme.borderRadius,
        fontSize: 13,
        fontFamily: theme.fontFamily,
        color: theme.textPrimary,
        wordBreak: 'break-all'
    },
    actions: {
        marginTop: 24,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 12
    }
}))

export default function WebhookDeleteModal({
    open,
    webhook,
    onCancel,
    onConfirm,
    isDeleting
}) {
    const classes = useStyles()
    const locale = useSelector(
        state => state.main.locale.integrations.webhooksTab
    )

    if (!webhook) return null

    return (
        <Modal open={open} setOpen={onCancel} size="sm">
            <Typography className={classes.title}>
                {locale.deleteWebhook}
            </Typography>
            <Typography className={classes.body}>
                {locale.confirmDeleteWebhook}
            </Typography>
            <div className={classes.target}>
                <strong>{webhook.name}</strong>
                <div>{webhook.endpoint}</div>
            </div>
            <div className={classes.actions}>
                <Button reverted onClick={onCancel} disabled={isDeleting}>
                    {locale.cancel}
                </Button>
                <Button error onClick={onConfirm} disabled={isDeleting}>
                    {locale.deleteWebhook}
                </Button>
            </div>
        </Modal>
    )
}
